/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($username: String!) {
    getUser(username: $username) {
      username
      profileUsername
      sub
      firstName
      lastName
      ssn
      terms
      birthdate
      alerus360id
      sponsor
      email
      emailVerified
      phone
      phones {
        id
        a360id
        countryCode
        number
        type
        createdAt
        updatedAt
        __typename
      }
      primary
      phoneVerified
      cif
      created
      lastModified
      enabled
      userStatus
      prefUsername
      userFlags
      country
      group
      snMFABypass
      awsMFA
      defaultMfa
      status
      passwordReset
      __typename
    }
  }
`;
export const getUsers = /* GraphQL */ `
  query GetUsers($token: String) {
    getUsers(token: $token) {
      Users {
        username
        profileUsername
        sub
        firstName
        lastName
        ssn
        terms
        birthdate
        alerus360id
        sponsor
        email
        emailVerified
        phone
        primary
        phoneVerified
        cif
        created
        lastModified
        enabled
        userStatus
        prefUsername
        userFlags
        country
        group
        snMFABypass
        awsMFA
        defaultMfa
        status
        passwordReset
        __typename
      }
      Token
      __typename
    }
  }
`;
export const getPoolCount = /* GraphQL */ `
  query GetPoolCount {
    getPoolCount
  }
`;
export const getConfig = /* GraphQL */ `
  query GetConfig {
    getConfig {
      env
      maintenance
      message
      __typename
    }
  }
`;
export const getContainers = /* GraphQL */ `
  query GetContainers {
    getContainers {
      name
      label
      weight
      __typename
    }
  }
`;
export const getAuthEvents = /* GraphQL */ `
  query GetAuthEvents($username: String) {
    getAuthEvents(username: $username) {
      events {
        id
        createdAt
        app
        action
        actionBy
        actionOn
        currVal
        newVal
        ipAddress
        browserDetails
        userAgent
        a360id
        cif
        updatedAt
        __typename
      }
      token
      error
      __typename
    }
  }
`;
export const searchUsers = /* GraphQL */ `
  query SearchUsers($term: String, $ssn: Boolean) {
    searchUsers(term: $term, ssn: $ssn) {
      username
      profileUsername
      sub
      firstName
      lastName
      ssn
      terms
      birthdate
      alerus360id
      sponsor
      email
      emailVerified
      phone
      phones {
        id
        a360id
        countryCode
        number
        type
        createdAt
        updatedAt
        __typename
      }
      primary
      phoneVerified
      cif
      created
      lastModified
      enabled
      userStatus
      prefUsername
      userFlags
      country
      group
      snMFABypass
      awsMFA
      defaultMfa
      status
      passwordReset
      __typename
    }
  }
`;
export const sendPasscode = /* GraphQL */ `
  query SendPasscode($message: String, $number: String) {
    sendPasscode(message: $message, number: $number)
  }
`;
export const getLog = /* GraphQL */ `
  query GetLog($actionOn: String!, $createdAt: AWSDateTime!) {
    getLog(actionOn: $actionOn, createdAt: $createdAt) {
      id
      createdAt
      app
      action
      actionBy
      actionOn
      currVal
      newVal
      ipAddress
      browserDetails
      userAgent
      a360id
      cif
      updatedAt
      __typename
    }
  }
`;
export const listLogs = /* GraphQL */ `
  query ListLogs(
    $actionOn: String
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLogs(
      actionOn: $actionOn
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        createdAt
        app
        action
        actionBy
        actionOn
        currVal
        newVal
        ipAddress
        browserDetails
        userAgent
        a360id
        cif
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const logsByA360 = /* GraphQL */ `
  query LogsByA360(
    $a360id: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    logsByA360(
      a360id: $a360id
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        app
        action
        actionBy
        actionOn
        currVal
        newVal
        ipAddress
        browserDetails
        userAgent
        a360id
        cif
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getIp = /* GraphQL */ `
  query GetIp($address: String!) {
    getIp(address: $address) {
      address
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listIps = /* GraphQL */ `
  query ListIps(
    $address: String
    $filter: ModelIpFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listIps(
      address: $address
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        address
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRestricted = /* GraphQL */ `
  query GetRestricted($a360id: String!) {
    getRestricted(a360id: $a360id) {
      a360id
      attempts
      lastAttempt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRestricteds = /* GraphQL */ `
  query ListRestricteds(
    $a360id: String
    $filter: ModelRestrictedFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRestricteds(
      a360id: $a360id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        a360id
        attempts
        lastAttempt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDocument = /* GraphQL */ `
  query GetDocument($id: ID!) {
    getDocument(id: $id) {
      id
      documentId
      name
      container
      lob
      filterType
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDocuments = /* GraphQL */ `
  query ListDocuments(
    $filter: ModelDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDocuments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        documentId
        name
        container
        lob
        filterType
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const docsByContainer = /* GraphQL */ `
  query DocsByContainer(
    $container: String
    $sortDirection: ModelSortDirection
    $filter: ModelDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    docsByContainer(
      container: $container
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        documentId
        name
        container
        lob
        filterType
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const docsByLOB = /* GraphQL */ `
  query DocsByLOB(
    $lob: String
    $sortDirection: ModelSortDirection
    $filter: ModelDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    docsByLOB(
      lob: $lob
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        documentId
        name
        container
        lob
        filterType
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
